<mat-card>
    <p>¿No vas aprovechar a agregar más ofertas en la bolsa?</p>
    <div class="button-actions">
        <button mat-stroked-button type="button" (click)="closeDialog('cancel')">Agregar más</button>
        <button mat-button type="button" (click)="closeDialog('save')" cdkFocusInitial>Continuar</button>
    </div>
</mat-card>
